import React from 'react';
import TagItem from './TagItem';
import './styles.scss';

const TagsFilter = ({ tags = [], selectedTag, onClick, showAllName }) => {
    return (
        <div className="tags-filter">
            <TagItem name={showAllName} selectedName={selectedTag} onClick={onClick} />
            {tags.map(name => (
                <TagItem key={name} name={name} selectedName={selectedTag} onClick={onClick} />
            ))}
        </div>
    );
};

export default TagsFilter;
